import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { EM_DASH } from 'constants/ui';

import { metaItemStyles } from './MetaItem.styles';

const MetaItem = ({ label, value = null }) => (
  <Box sx={metaItemStyles}>
    <Typography color="text.secondary" variant="regular12">
      {label}
    </Typography>
    <Typography variant="regular14">{value || EM_DASH}</Typography>
  </Box>
);

MetaItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

export default MetaItem;
